import { Component, OnInit, OnDestroy } from '@angular/core';
import { MessagesFacade } from '../_services/messages.facade';
import { Message } from '../interfaces/Message';
import { tap, flatMap, takeUntil, debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { Subject, observable } from 'rxjs';
// import { ThrowStmt } from '@angular/compiler';
import { GlobalService } from 'src/app/_services/global.service';

@Component({
  selector: 'app-messages-container',
  templateUrl: './messages-container.component.html',
  styleUrls: ['./messages-container.component.scss']
})
export class MessagesContainerComponent implements OnInit, OnDestroy {
  destroy$: Subject<boolean> = new Subject<boolean>();
  messagesList: Message[];
  messagesCompact: Message[];
  currentMessage: Message;
  viewType: string = 'list';
  pageNumber: number = 1;
  itemsPerPage: number = 25;
  countOfMessages: number = 0;
  paginatorInfo = {
    countOfMessages: 0,
    from: 1,
    to: 25
  }
  searchTerms = new Subject<string>();
  searchText: string;
  sortType: string = 'desc';
  isLoading: boolean = false;
  noResultsFlag: boolean = false;
  currLang;
  constructor(public messagesFacade: MessagesFacade,
    private globalService: GlobalService) { }

  ngOnInit(): void {
    // this.messagesFacade.getCurrentPage$().pipe(takeUntil(this.destroy$)).subscribe(page=>{
    //   this.messagesFacade.setMessageListView(10, page);
    // })
    this.globalService.getLang().subscribe(lng =>{
      this.currLang = lng;
    });
    this.messagesFacade.loadAllMessages();
    this.messagesFacade.getAllMessages$().pipe(takeUntil(this.destroy$)).subscribe(res => {
      if (res) {
        this.messagesList = res;
        this.messagesFacade.setMessageById(this.messagesList[0]?.id); // default message 
        this.setMessages();
      }
    })

    this.messagesFacade.getReloadMessages().subscribe((res: any) => {
      if (res) {
        this.setMessages();
      }
    })

    this.messagesFacade.getMessagesCompactView$().subscribe(res => {
      this.messagesFacade.getMessageCount$().subscribe(res => {
        this.countOfMessages = res;
        this.paginatorInfo =
          { countOfMessages: this.countOfMessages, from: ((this.itemsPerPage * this.pageNumber) - this.itemsPerPage) + 1, to: this.itemsPerPage * this.pageNumber > this.countOfMessages ? this.countOfMessages : this.itemsPerPage * this.pageNumber }
      })
      this.messagesCompact = res;
    })


    this.messagesFacade.getCurrentMessage$().subscribe(currentMessage => {
      this.currentMessage = currentMessage
    })

    // changing this will reduce the api calls by one but will mess up other features 
    this.searchTerms.
      pipe(tap(() => this.messagesFacade.isLoading = true), debounceTime(500), distinctUntilChanged(), switchMap((text: any) => {
        return this.messagesFacade.setMessagesCompactView(this.itemsPerPage, this.pageNumber, this.sortType, text)
      }
      )

      ).subscribe((res: any) => {
        this.messagesFacade.isLoading = false
        this.globalService.stopLoading();
        this.messagesFacade.setMessageCount(this.searchText)
        this.messagesList = res.data; //for list view
        this.messagesFacade.setMessageById(this.messagesList[0].id); // default message
        this.messagesFacade.setMessagesCompactViewState(res.data); // for compact view


        
      })
  }

  setViewType(type: string) {
    this.viewType = type;
  }
  setItemsPerPage($event) {
    this.itemsPerPage = $event;
    this.setMessages();
  }

  setMessages() {
    this.messagesFacade.isLoading = true
    this.globalService.startLoading();
    if (this.searchText) {
      this.messagesFacade.setMessagesCompactView(this.itemsPerPage, this.pageNumber, this.sortType, this.searchText).subscribe((res: any) => {
        this.noResultsFlag=false;
        this.messagesList = res.data; //for list view
        if( this.messagesList.length==0){
          this.noResultsFlag=true;
        }
        
        this.messagesFacade.setMessagesCompactViewState(this.messagesList); // for compact view
        this.messagesFacade.isLoading = false
        this.globalService.stopLoading();
      })
      return
    }
    this.messagesFacade.setMessagesCompactView(this.itemsPerPage, this.pageNumber, this.sortType).subscribe((res: any) => {
      this.messagesList = res.data; //for list view
      this.messagesFacade.setMessageById(this.messagesList[0]?.id); // default message
      this.messagesFacade.setMessagesCompactViewState(this.messagesList); // for compact view
      this.messagesFacade.isLoading = false
      this.globalService.stopLoading();
    })
  }

  paginationHandler(value) { // previous or next
    if (value == 'previous') {
      if (this.pageNumber > 1) {
        this.pageNumber = this.pageNumber - 1
      } else { return }
    }
    else {
      const numberOfPages = Math.ceil((this.countOfMessages / this.itemsPerPage))

      if (this.pageNumber < numberOfPages) {
        this.pageNumber = this.pageNumber + 1
      } else {
        return
      }
    }
    this.setMessages();
  }


  searchInMessages(text) {
    this.pageNumber = 1;
    if (text) {
      this.searchTerms.next(text);
      this.searchText = text;
      this.setMessages();
    } else {
      this.searchText = null;
      this.noResultsFlag=false
      this.messagesFacade.loadAllMessages();
    }
  }

  sortTable($event) {
    this.sortType = $event;
    this.messagesFacade.isLoading = true;
    this.globalService.startLoading();
    if (!this.searchText) {
      this.messagesFacade.sortMessages(this.itemsPerPage, this.pageNumber, this.sortType)
      // this.setMessages();
      return
    }
    this.messagesFacade.sortMessages(this.itemsPerPage, this.pageNumber, this.sortType, this.searchText)
  }

  onScrollList(event) {
    if (!this.searchText) this.messagesFacade.setCurrentPage();
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
